import React, {FC} from 'react';
import {Platform, Text} from 'react-native';
import {MainContainer} from '@fkhplus/common/src/components/templates/PlayGround/style';
import WebOTP from '@fkhplus/common/src/components/templates/PlayGround/WebOTP';

const PlayGround: FC = () => {
    return (
        <MainContainer style={{height: Platform.OS === 'web' ? '100vh' : '100%'}}>
            <WebOTP/>
        </MainContainer>
    );
};
export default PlayGround;
